<template>
  <AuthLayout :heading="$nt('heading')">
    <VForm
      ref="isFormValid"
      v-model="isFormValid"
      @submit.prevent="submit"
    >
      <EmailInput
        v-model="email"
      />
    </VForm>
    <template slot="navigation">
      <VBtn
        flat
        :to="{name: 'login'}"
      >
        {{ $nt('back') }}
      </VBtn>
    </template>
    <template slot="action">
      <VBtn
        :disabled="!isFormValid || isLoading"
        :loading="isLoading"
        color="primary"
        @click="submit"
      >
        {{ $nt('send') }}
      </VBtn>
    </template>
  </AuthLayout>
</template>

<script>
import UserApi from '@/api/UserApi'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import AuthLayout from '@/components/layouts/AuthLayout'

export default {
  name: 'PasswordForgot',
  components: { AuthLayout, EmailInput },
  props: [],
  data () {
    return {
      isFormValid: false,
      isLoading: false,
      email: ''
    }
  },
  methods: {
    async submit () {
      if (this.isFormValid) {
        this.isLoading = true
        try {
          const response = await UserApi.forgotPassword(this.email)
          this.$refs.isFormValid.reset()
          this.$notification(response)
        } catch (e) {
          this.$notification(e)
        }
        this.isLoading = false
      }
    }
  }
}
</script>
